import React, { useState } from "react";
import { Options } from "../../../Layout/Shared/DropdownOptionsMenu";
import { ThreeDotIcon } from "../../../../assets/icons/icon";
import { DeleteModal } from "../../../Layout/Shared/Popups/Delete";
import { deleteStage } from "../../../../data/CaseManagement/stages";

export const ActionButtons = ({
  stage,
  setStage,
  setShowFormModal,
  refresh
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    setSubmitting(true);
    const { hasSuccess } = await deleteStage(stage._id);
    if (hasSuccess) {
      await refresh();
      setShowDelete(false);
    }
    setSubmitting(false);
  };

  return (
    <>
      {submitting ? (
        <span className="dots-loading">{ThreeDotIcon}</span>
      ) : (
        <Options
          arrow={false}
          buttonTitle={ThreeDotIcon}
          menuItems={
            <div>
              <button
                onClick={() => {
                  setShowDelete(false);
                  setStage(stage);
                  setShowFormModal(true);
                }}
              >
                Edit
              </button>

              <button
                className="text-danger"
                onClick={() => {
                  // setShowFormModal(false);
                  // setType({});
                  setShowDelete(true);
                }}
              >
                Delete
              </button>
            </div>
          }
        />
      )}

      {showDelete && (
        <DeleteModal
          title="Delete Stage"
          text="You are about to delete this stage from your stage list. Deleting
          this stage removes all stage’s information and ends all previous
          communication between you and the stage."
          buttonText="Delete"
          onConfirm={handleDelete}
          onClose={() => setShowDelete(false)}
        />
      )}
    </>
  );
};
